import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PolicyRoutingModule } from './policy-routing.module';
import { PolicyComponent } from './components/policy/policy.component';
import { MatDialogModule } from '@angular/material/dialog';
// import { FooterModule } from 'src/app/shares/footer/footer.module';


@NgModule({
  declarations: [PolicyComponent],
  imports: [
    CommonModule,
    PolicyRoutingModule,
    MatDialogModule,
    // FooterModule
  ]
})
export class PolicyModule { }
